// NEXUS — Modelo de operação do tenant (tradicional | operacional).
//
// Fonte ÚNICA de rótulos/descrições e da leitura do modelo no frontend. O
// BACKEND é quem decide (ver company_modelo_operacao/is_operational_company
// em server.py) — aqui é só exibição e gating VISUAL, nunca a autoridade:
// mesmo que alguém force o modelo no navegador, as rotas operacionais
// continuam devolvendo 403 num tenant tradicional.
export const MODELO_TRADICIONAL = "tradicional";
export const MODELO_OPERACIONAL = "operacional";

export const MODELOS_OPERACAO = [
  {
    valor: MODELO_TRADICIONAL,
    label: "Tradicional",
    descricao:
      "Fluxo atual do LOOTUS, com ficha de serviço, horas, encerramento, assinatura e faturamento.",
    badge: "bg-slate-100 text-slate-700",
  },
  {
    valor: MODELO_OPERACIONAL,
    label: "Operacional",
    descricao:
      "Fluxo completo com prioridade, SLA, planejamento, execução e gestão operacional.",
    badge: "bg-indigo-100 text-indigo-800",
  },
];

/** Modelo EFETIVO — ausente/desconhecido é tradicional (mesma regra do backend). */
export const modeloOperacaoDe = (obj) => {
  const m = obj?.modelo_operacao;
  return m === MODELO_OPERACIONAL ? MODELO_OPERACIONAL : MODELO_TRADICIONAL;
};

export const isOperacional = (obj) => modeloOperacaoDe(obj) === MODELO_OPERACIONAL;

export const modeloMeta = (valor) =>
  MODELOS_OPERACAO.find((m) => m.valor === valor) || MODELOS_OPERACAO[0];
